export const versionControl = () => {
  localStorage.clear();
  window.location.reload(true);
};
